<template lang="pug">
v-pagination(
  v-model="tableOptions.page"
  :length="pageCount"
  :loading="loading"
)
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useVehicleListStore } from '@/stores/views/useVehicleListStore';

export default {
  computed: {
    ...mapState(useVehicleListStore, ['totalItems', 'loading']),
    ...mapWritableState(useVehicleListStore, ['tableOptions']),

    pageCount() {
      return Math.ceil(this.totalItems / this.tableOptions.itemsPerPage)
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
